import React, { useState } from 'react';
import './style.css';
import CreatePlanFlow from '/src/Components/CreatePlanFlow/CreatePlanFlow';
import CTAButton from '/src/Components/CTAButton/CTAButton';

const CreateAPlan = ({ propertyData, projects, userPlans, setUserPlans, userInsurance, handleCreatePlanComplete }) => {

    const property_id = propertyData?.address_id;

    const [userGetStartedClicked, setUserGetStartedClicked] = useState(false);

    const header = userPlans.length === 0 ? "Create Your First Plan" : "Create a New Plan";
    const intro_sentence = userPlans.length === 0 ? "In order to make taking action easier, we'll create a plan for you based on the projects you're interested in and your thinking of how you want to go about the improvements." : "We're here to help you create a plan for your property. We'll walk you through the process step by step.";


    const handleComplete = (newPlan) => {
        
        setUserPlans([...userPlans, newPlan]);
        handleCreatePlanComplete();
    }

    return (
        <div className="taking-action-section-container">
            <h1>{header}</h1>
            {!userGetStartedClicked &&
                <>
                    <p className="taking-action-intro-sentence text-align-center">{intro_sentence}</p>
                    <CTAButton text="Get Started" onClick={() => setUserGetStartedClicked(true)} />
                </>
            }
            {userGetStartedClicked && (
                <CreatePlanFlow
                    projects={projects}
                    onComplete={handleComplete}
                    userInsurance={userInsurance}
                    property_data={propertyData}
                    property_id={property_id}
                    userPlans={userPlans}
                />
            )}
        </div>
    );
};

export default CreateAPlan;